import { useEffect, useRef, useState } from 'react';
import CompanyBillingHistoryCard from './CompanyBillingHistoryCard';
import CompanyBillingInformationCard from './CompanyBillingInformationCard';
import CompanyBillingNotificationsCard from './CompanyBillingNotificationsCard';
import { EDITOR_ROLES } from './overviewLayout';

/**
 * The « Factures » tab of the company panel, shown with the invoice access
 * only: the billing information (JBWEB-1268), who receives the invoices
 * (JBWEB-1285) and the company's invoices by year (JBWEB-1308). Editing
 * follows the same roles as the overview.
 *
 * The panel mounts it hidden as soon as it opens, so that the tab is read
 * before it is chosen. `isShown` says when it is on screen: each time it comes
 * back, its cards read their data again behind what they show, since another
 * tab (the members) may have changed who receives the invoices.
 */
const SlideOverCompanyInvoicesTab = ({
  companyInfo,
  userData,
  isShown = true,
}) => {
  const canEdit = EDITOR_ROLES.includes(userData?.role);
  const [refreshKey, setRefreshKey] = useState(0);
  const wasShown = useRef(isShown);

  useEffect(() => {
    if (isShown && !wasShown.current) setRefreshKey((key) => key + 1);
    wasShown.current = isShown;
  }, [isShown]);

  return (
    <>
      <CompanyBillingInformationCard
        idCompany={companyInfo?._id}
        canEdit={canEdit}
        refreshKey={refreshKey}
      />
      <CompanyBillingNotificationsCard
        idCompany={companyInfo?._id}
        canEdit={canEdit}
        refreshKey={refreshKey}
      />
      <CompanyBillingHistoryCard
        idCompany={companyInfo?._id}
        companyName={companyInfo?.name_commercial || companyInfo?.reason_social}
        refreshKey={refreshKey}
      />
    </>
  );
};

export default SlideOverCompanyInvoicesTab;
